import { serverFetch } from "@core/server";

export function fetchSprSotrList(q) {
  return serverFetch("sprs/sotr", {
    queryParams: q ? { q } : undefined
  });
}

export function fetchSprSotr(idSotr) {
  return serverFetch(`sprs/sotr/${idSotr}`);
}

export function createSprSotr(bodyData) {
  return serverFetch("sprs/sotr", {
    method: "POST",
    bodyData
  });
}

export function saveSprSotr(bodyData) {
  return serverFetch("sprs/sotr", {
    method: "PUT",
    bodyData
  });
}

export function deleteSprSotr(idSotr) {
  return serverFetch(`sprs/sotr/${idSotr}`, {
    method: "DELETE"
  });
}

export function setSprSotrPassword(idSotr, password) {
  return serverFetch(`sprs/sotr/${idSotr}/password`, {
    method: "POST",
    bodyData: { password }
  });
}

export function clearSprSotrPassword(idSotr) {
  return serverFetch(`sprs/sotr/${idSotr}/password/clear`, {
    method: "POST"
  });
}
